import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Page } from '../../../models/page.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { PageService } from '../../../services/page/page.service';
import { MatDialog } from '@angular/material/dialog';
import { PagedResult } from '../../../models/pagedResult.model';
import { DialogService } from '../../../services/shared/dialog/dialog.service';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { UtilsService } from '../../../services/shared/utils/utils.service';
import { PageType } from '../../../shared/enums/page-type/page-type.module';
import { AddPageModalComponent } from '../../../shared/components/add-page-modal/add-page-modal.component';
import { GeneralParameterService } from '../../../services/generalparameter/generalparameter.service';
import { GeneralParameter } from '../../../models/generalParameter.model';
import { RolePageConfig } from '../../../models/rolePageConfig.model';
import { merge, Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../services/shared/common/common.service';
import { LoadingService } from '../../../services/loading/loading.service';
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.css'
})
export class PagesComponent implements OnInit, AfterViewInit, OnDestroy{
  private destroy$ = new Subject<void>();

  displayedColumns: string[] = ['title', 'type', 'offers','order', 'actions'];
  PageType = PageType;
  dataSource = new MatTableDataSource<Page>();
  totalItems = 0;
  defaultRoles: RolePageConfig[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  search: string = "";

  constructor(private router: Router,
    private pageService: PageService,
    public dialog: MatDialog,
    private dialogService: DialogService,
    private snackBar: SnackbarService,
    public translationService: TranslationService,
    public utils: UtilsService,
    public common: CommonService,
    private generalParameterService: GeneralParameterService,
    private loadingService: LoadingService) { }

  ngOnInit() {
    this.getPages();
    this.getRolesPageConfig();
  }

  ngAfterViewInit() {
    this.sort.sortChange
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.paginator.pageIndex = 0;
    });

    merge(this.paginator.page, this.sort.sortChange)
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.getPages();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  applyFilter(event: KeyboardEvent) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.search = filterValue.trim().toLowerCase();
    this.paginator.pageIndex = 0;
    this.getPages();
  }

  getPages() {
    const pageIndex = this.paginator?.pageIndex ?? 0;
    const pageSize = this.paginator?.pageSize ?? 10;
    this.loadingService.show();
    this.pageService.getPages(pageIndex + 1, pageSize, this.search)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (result: PagedResult<Page>) => {
        this.totalItems = result.totalCount;

        this.dataSource.data = this.common.orderPages(result.items);
        this.loadingService.hide();
      },
      error: (error) => {
        this.loadingService.hide();

        this.snackBar.showError(this.translationService.translate('Error fetching pages'));
      }
    });
  }
  deletePage(e: MouseEvent, page: Page): void {
    e.preventDefault();
    e.stopPropagation();
    this.dialogService
    .confirm(this.translationService.translate('Confirm Delete'), this.translationService.translate('Are you sure you want to delete this page?'))
    .then((confirmed) => {
      if (confirmed) {
        if (page.id && (page.offers == null || page.offers.length <= 0)) {
          this.pageService.deletePage(page.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (data: Page) => {
              this.snackBar.showSuccess(this.translationService.translate('Page deleted successfully'));
              this.getPages();
            },
            error: (error) => {
              this.snackBar.showError(this.translationService.translate('Error fetching page'));
            }
          });
        } else {
          this.snackBar.showError(this.translationService.translate('ID is null'));
        }
      }
    });
  }

  navigateToPage(pageId: string) {
    this.router.navigate(['/admin/pages/', pageId]);
  }

  addNewPage()
  {
    //modal
    const dialogRef = this.dialog.open(AddPageModalComponent, {
      width: '500px',
      data: {
        defaultRoles: this.defaultRoles
      }
    });

    dialogRef.afterClosed().subscribe(pageId => {
      if(pageId != undefined && pageId != ""){
        this.router.navigate(['/admin/pages/', pageId]);
      }
    });
  }

  getRolesPageConfig(): void {
    this.generalParameterService.getGeneralParameters('RolesPageConfig')
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (param: GeneralParameter[] | GeneralParameter) => {
        if (param != null && param.values.length > 0) {
          this.defaultRoles = (param.values) as RolePageConfig[];
        }
      },
      error: (error) => {
        this.defaultRoles = [];
      }
    });
  }
}
